import useImages from '@hooks/useImages'

import {
  Box, Form, Grid, Link, SidebarNoticeBox,
} from '@domain-group/suit-theme'

import ImageListItem from '../ImageListItem'

interface ImageListProps {
  imageableId: number,
  imageableType: string,
}

const ImageList = (props: ImageListProps) => {
  const { imageableId, imageableType } = props

  const imagesPayload = useImages({
    filters: {
      imageable_id: imageableId,
      imageable_type: imageableType,
    },
    performHttpRequests: true,
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredImages,
    hasFilteredImages,
    loading,
  } = imagesPayload

  return (
    <Box flexDirection="column" title="Library Images">
      <Form.Field label="Library Images " marginTop="large">
        {!loading && !hasFilteredImages && (
          <SidebarNoticeBox boxProps={{ marginBottom: 'none' }}>
            <SidebarNoticeBox.Title>No Images Present</SidebarNoticeBox.Title>
          </SidebarNoticeBox>
        )}

        {!loading && hasFilteredImages && (
          <Grid
            // @ts-expect-error TS2322
            gridAutoRows="1fr"
            gridColumnGap="small"
            gridRowGap="small"
            gridTemplateColumns="repeat(auto-fill, minmax(100px, 1fr))"
            gridTemplateRows="repeat(auto-fill, minmax(100px, 1fr))"
          >
            {filteredImages.map(image => (
              // @ts-expect-error TS2322
              <ImageListItem key={image.id} image={image} />
            ))}
          </Grid>
        )}

        {canLoadMore && (
          <Link
            onClick={() => loadMore()}
            textProps={{ fontSize: 'small', marginLeft: 'auto', marginTop: 'medium' }}
          >
            Load More
          </Link>
        )}
      </Form.Field>
    </Box>
  )
}

export default ImageList
